import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogTitle } from '../ui/Dialog'
import { PublishIssue } from '../../api/edits/editRoute.responses';
import { Button } from '../ui/Button';



interface IssueDialogProps {
  isIssuesDialogOpen: boolean;
  setIsIssuesDialogOpen: (open: boolean) => void;
  publishIssues: PublishIssue[];
}

function IssueDialog({ isIssuesDialogOpen, setIsIssuesDialogOpen, publishIssues }: IssueDialogProps) {
  return (
    <Dialog
    open={isIssuesDialogOpen}
    onOpenChange={setIsIssuesDialogOpen}
    modal={false}
  >
    <DialogOverlay className="!bg-transparent pointer-events-none" />
    <DialogContent
      className="fixed bottom-6 left-6 top-auto translate-x-0 translate-y-0 sm:max-w-[420px] flex flex-col max-h-[60vh]"
      onPointerDownOutside={(e) => e.preventDefault()}
      onFocusOutside={(e) => e.preventDefault()}
    >
      <DialogHeader>
        <DialogTitle>Route is not ready to publish</DialogTitle>
        <DialogDescription>
          Fix the following issues before publishing:
        </DialogDescription>
      </DialogHeader>
      <ul className="flex-1 overflow-y-auto mt-2 space-y-2">
        {publishIssues.map((issue, i) => (
          <li key={i} className="flex flex-col text-sm">
            <span className="font-medium text-destructive">{issue.field}</span>
            <span className="text-muted-foreground">{issue.message}</span>
          </li>
        ))}
      </ul>
      <DialogFooter className="mt-4 sticky bottom-0 bg-background pt-2">
        <DialogClose asChild>
          <Button variant="secondary">Close</Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  )
}

export default IssueDialog